import { IonCard, IonIcon } from "@ionic/react";
import { ComponentProps, ReactNode, RefObject } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import PrimaryButton from "@components/buttons/PrimaryButton";
import styles from "@components/layout/Section.module.css";
import BodyCopy from "@components/typography/BodyCopy";
import Heading2 from "@components/typography/Heading2";
import { Colors } from "@utils/colorUtils";
import { IconList, IconName } from "@utils/iconUtils";

type Props = {
  buttonProps?: ComponentProps<typeof PrimaryButton>;
  children: ReactNode;
  color: Colors;
  descriptionKey?: string;
  icon: IconName;
  scrollRef?: RefObject<HTMLDivElement>;
  titleKey: string;
};

const Section = ({ buttonProps, children, color, descriptionKey, icon, scrollRef, titleKey }: Props) => {
  const intl = useIntl();

  return (
    <div className={styles.section} ref={scrollRef}>
      <div className={styles.buttonFlex}>
        <div className={styles.header}>
          <div>
            <IonCard className={`${styles.icon} ${!descriptionKey ? styles.noDescriptionIcon : ""}`} color={color}>
              <IonIcon
                aria-label={intl.formatMessage({ id: titleKey })}
                className={styles.largeIcon}
                data-test="icon"
                src={IconList[icon]}
              />
            </IonCard>
          </div>

          <div>
            <div className={styles.titleSpacing}>
              <Heading2>
                <FormattedMessage id={titleKey} />
              </Heading2>
            </div>
            {descriptionKey && (
              <div>
                <BodyCopy color="primary">
                  <FormattedMessage id={descriptionKey} />
                </BodyCopy>
              </div>
            )}
          </div>
        </div>

        {buttonProps && <PrimaryButton {...buttonProps} />}
      </div>

      {children}
    </div>
  );
};

export default Section;
